import { UseMutationOptions, UseMutationResult, useMutation } from '@tanstack/react-query';
import axios from 'axios';

export const useConvertToDraftMutation = (
  options: Omit<UseMutationOptions<unknown, unknown, number, unknown>, 'mutationFn'> = {}
): UseMutationResult<unknown, unknown, number, unknown> => {
  return useMutation({
    mutationFn: (roleId: number) => axios.post(`/api/roles/${roleId}/convert_to_draft/`),
    ...options,
    onSuccess: (data, variables, context) => {
      options.onSuccess?.(data, variables, context);
    },
    onError: (data, variables, context) => {
      options.onError?.(data, variables, context);
    },
  });
};
